<template>
    <div>
        <h1>Backend</h1>
        <p>So you want to code backend, huh? Nice! First thing; you need to install <a target="_blank" href="https://www.getpostman.com/">Postman</a>.</p>
        <p>Postman is a great tool for trying different REST-calls locally. I'm sure you've heard of it.</p>
        <p>Your backend needs to implement all of the interfaces specified in the <router-link to="/api">API specification</router-link>. For your convenience, here is a fully populated <a href="/ServerlessKitchen.postman_collection.json" download="ServerlessKitchen.postman_collection.json">Postman Collection</a>. <span class="comment">/* you may have to save the file as a .json to your disk if it opens in the browser */</span></p>
        
        <BackendMission></BackendMission>
        
        <h3>Choose your stack:</h3>
        <p>Difficult choice? Then do them all ;)</p>
        <LinkBox>
            <li><router-link to="/backend-java">Goto: Java8+ &amp; Spring Boot</router-link></li>
            <li><router-link to="/backend-dot-net">Goto: .NET</router-link></li>
        </LinkBox>
    </div>
</template>



<script>
import LinkBox from '@/components/LinkBox.vue'
import BackendMission from '@/components/BackendMission.vue'

export default {
    name: 'backend',
    components: {
        LinkBox,
        BackendMission
    }
}
</script>

<style scoped>

</style>
